import React, { useState, useEffect } from 'react'

import { Row, Col, Form, Input, Select, Button, Table, notification } from 'antd'

import styled from 'styled-components'
import ColorList from 'constants/color.constants'
import { SearchOutlined } from '@ant-design/icons'

import {
  getMemberAssignee,
  getPermissionAssignee,
  editPermissionAssignee,
} from 'api/Project/sprintFlow'

import { getCookie } from 'helper/cookie'

const Container = styled.div`
  background-color: ${ColorList.white};

  width: 100;
  height: auto;
  margin-top: 16px;
  margin-left: 4px;
`

const initalState = {
  data: [],
  isLoading: true,
}
import lang from 'lang/en'

const AddTaskAssignee = (props) => {
  ///lang
  const language = getCookie('lang')
  const word = lang[language]
  const { swithCaseTaskFLowFunction, role, idEditPRJ } = props

  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const token = getCookie('access_token_admin')

  const [dataMember, setDataMember] = useState(initalState.data)
  const [dataPermission, setDataPermission] = useState(initalState.data)
  const [SearchTerm, setSearchTerm] = useState('')

  const [form] = Form.useForm()

  const handleEditPermissionAssignee = (item) => {
    const dataArray = {
      project_id: parseInt(idEditPRJ),
      sprintflow_id: props.id,
      account_id: item.account_id,
      permission: 5,
    }
    try {
      editPermissionAssignee({
        params: dataArray,
        token: token,
      }).then(async (response) => {
        const { status, data } = response
        if (status == 200) {
          return data
          // swithCaseTaskFLowFunction('')
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const getMemberData = async () => {
    await getMemberAssignee({
      sprintflow_id: props.id,
      project_id: parseInt(idEditPRJ),
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          await setDataMember([])

          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          if (data.member == null) {
            setDataMember([])
          } else {
            // data.member.map((item) => {
            //   if (item.permission == 0) {
            //   } else {
            //     if (item.permission != 7) {
            //       count = count + 1
            //     }
            //   }
            // })
            // if (count <= 1) {
            //   setDisabledSave(true)
            // }
            await setDataMember(data.member)
            data.member.map((item) => {
              if (item.permission == 0) {
                item.permission = 5
              }
              // if (item.permission == 7) {
              //   // handleEditPermissionAssignee(item)
              //   item.permission = 5
              // }
              if (item.role == 'Project Leader') {
                item.permission = 5
              }
              form.setFieldsValue({
                [item.firstname + item.role]: item.permission,
              })
            })
          }
          await setIsLoading(false)
        } else {
          setDataMember([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataMember([])
        setIsLoading(false)
        console.error(error)
      })
  }

  const getPrmissionData = async () => {
    await getPermissionAssignee({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          await setDataPermission([])

          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          await setDataPermission(data)
          await setIsLoading(false)
        } else {
          setDataPermission([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataPermission([])
        setIsLoading(false)
        console.error(error)
      })
  }

  useEffect(() => {
    if (token) {
      getMemberData()
      getPrmissionData()
      return () => {
        // getMemberData()
        // getPrmissionData()
      }
    }
  }, [token])

  // useEffect(() => {
  //   if (dataMember.length > 0) {
  //     const fetchData = async () => {
  //       try {
  //         await getMemberData()
  //       } catch (error) {
  //         console.error('Error fetching member data:', error)
  //       }
  //     }
  //     fetchData()
  //   }
  // }, [dataMember])

  const openNotificationWithIcon = (
    type,
    account_id,
    firstname,
    lastname,
    permission,
  ) => {
    let a = permission
    dataPermission.map((item) => {
      if (permission == item.id) {
        a = item.title
      }
    })
    notification[type]({
      message: 'Success',
      description: firstname + ' ' + lastname + ' ' + 'has been ' + a.toLowerCase() + '.',
      duration: 3,
    })
  }

  const onChange = (e, record, notifi) => {
    const dataArray = {
      project_id: parseInt(idEditPRJ),
      sprintflow_id: props.id,
      account_id: record.account_id,
      permission: e,
    }
    // console.log(dataArray)
    try {
      editPermissionAssignee({
        params: dataArray,
        token: token,
      }).then(async (response) => {
        // console.log(response)
        const { status, data, error } = response
        // console.log(status)
        if (status == 200) {
          if (notifi == true) {
            openNotificationWithIcon(
              'success',
              record.account_id,
              record.firstname,
              record.lastname,
              e,
            )
          } else {
          }

          // swithCaseTaskFLowFunction('')
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const dataSource = dataMember
    .filter((item) =>
      [item.firstname, item.lastname, `${item.firstname} ${item.lastname}`].some((el) =>
        el.toLowerCase().includes(SearchTerm.toLowerCase()),
      ),
    )

    .map((item) => ({
      account_id: item.account_id,
      project_id: item.project_id,
      rolename: item.role,
      permissions: dataPermission,
      permissionsmember: item.permission,
      position: item.skill,
      firstname: item.firstname,
      lastname: item.lastname,
      pic_display: item.pic_display,
    }))

  const columns = [
    {
      title: word['addtask_assignee_title_rolename'],
      dataIndex: 'rolename',
      key: 'rolename',
      // width: 250,
      ellipsis: true,
      render: (text, record) => {
        return (
          <div>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <img
                className="imageStyle"
                src={record.pic_display}
                style={{ marginRight: 16 }}
              ></img>

              <div>
                <p>{text}</p>
                <small style={{ color: '#7C7C84' }}>
                  {record.firstname} {record.lastname}
                </small>
              </div>
            </div>
          </div>
        )
      },
    },
    {
      title: word['addtask_assignee_title_skills'],
      dataIndex: 'position',
      key: 'position',
      // width: 400,
      ellipsis: true,
    },
    {
      title: word['addtask_assignee_title_permission'],
      dataIndex: 'permissions',
      key: 'permissions',
      ellipsis: true,
      render: (text, record) => {
        if (record.rolename == 'Project Leader') {
          if (record.permissionsmember == 0) {
            if (role == true) {
            } else {
              onChange(5, record)
            }
          }
          return (
            <Form.Item name={record.firstname + record.rolename}>
              <p style={{ paddingLeft: 10 }}>{word['addtask_assignee_value_assignee']}</p>
            </Form.Item>
          )
        } else {
          if (role == true) {
            return (
              <div>
                <Form.Item
                  name={record.firstname + record.rolename}
                  className="disable-page"
                >
                  <Select
                    disabled
                    className="selectionassignee"
                    placeholder="dropdown"
                    style={{ width: 120 }}
                    onChange={(e) => onChange(e, record, false)}
                  >
                    {text
                      .filter(item => item.id !== 7 || item.id === record.permissionsmember)
                      .map((item) => (
                        <Option key={item.id} value={item.id} dataselect={item} datamember={record}>
                          {item.title}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </div>
            )
          } else {
            return (
              <div>
                <Form.Item name={record.firstname + record.rolename}>
                  <Select
                    id={`selectionassignee` + record.firstname}
                    className="selectionassignee"
                    placeholder="dropdown"
                    style={{ width: 120 }}
                    onChange={(e) => onChange(e, record, true)}
                  >
                    {text
                      .filter(item => item.id !== 7 || item.id === record.permissionsmember)
                      .map((item) => (
                        <Option key={item.id} value={item.id} dataselect={item} datamember={record}>
                          {item.title}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </div>
            )
          }
        }
      },
    },
  ]

  // const onFinish = async (values) => {
  //   console.log(values)
  //   dataMember.map((item) => {
  //     let formitemname = item.firstname + item.role

  //     const dataArray = {
  //       project_id: parseInt(idEditPRJ),
  //       sprintflow_id: props.id,
  //       account_id: item.account_id,
  //       permission: values[formitemname],
  //     }
  //     console.log(dataArray)
  //     try {
  //       editPermissionAssignee({
  //         params: dataArray,
  //         token: token,
  //       }).then(async (response) => {
  //         // console.log(response)
  //         const { status, data, error } = response
  //         console.log(status)
  //         if (status == 200) {
  //           swithCaseTaskFLowFunction('')
  //         }
  //       })
  //     } catch (error) {
  //       console.log(error)
  //     }
  //   })
  // }

  const onChangeSearch = (e) => {
    setSearchTerm(e.target.value)
  }

  // let a = ''
  // let b = ''
  // const onChangeForm = (e) => {
  //   e.map((item) => {
  //     if (item.value != 7) {
  //       if (a[0] == item.name[0]) {
  //         console.log('case1', item.name[0], a[0])
  //       } else {
  //         console.log('case2', item.name[0], a[0])

  //         count = count + 1
  //       }
  //     } else {
  //       count = count - 1
  //     }
  //     console.log(count)

  //     a = item.name
  //     // console.log(c)
  //     // b = item.value
  //     if (count >= 1) {
  //       setDisabledSave(false)
  //     } else if (count < 0) {
  //       setDisabledSave(true)
  //     }
  //   })
  // }

  // const checkcount = (count1) => {
  //   if (count1 >= 1) {
  //     setDisabledSave(false)
  //   } else if (count1 < 0) {
  //     setDisabledSave(true)
  //   }
  // }
  return (
    <Container style={{ minHeight: '65vh' }}>
      <Form
        form={form}
        name="addtaskassingee"
      // onFinish={onFinish}
      // onFieldsChange={onChangeForm}
      >
        <Row style={{ marginTop: 30 }}>
          <Col span={16}>
            <h4 style={{ marginTop: 0 }}>{word['addtask_assignee_title_member']}</h4>
          </Col>
          <Col span={8} style={{ paddingLeft: 7 }}>
            <Input
              id="SearchMember"
              prefix={<SearchOutlined />}
              placeholder="Search Member"
              type="text"
              // value={SearchTerm}
              onChange={onChangeSearch}
              size="large"
              allowClear
            />
          </Col>
        </Row>

        <Table
          id="tableassignee"
          className="tableassignee"
          style={{ marginTop: 16 }}
          dataSource={dataSource}
          columns={columns}
          pagination={false}
        />
      </Form>
    </Container>
  )
}
export default AddTaskAssignee
